export type PerformanceProfile = 'balanced' | 'low';

type NavigatorPerformanceHints = Pick<Navigator, 'hardwareConcurrency'> & {
  readonly deviceMemory?: number;
  readonly connection?: {
    readonly saveData?: boolean;
    readonly effectiveType?: string;
  };
};

export function resolvePerformanceProfile(
  navigatorHints: NavigatorPerformanceHints,
  reducedMotion: boolean,
): PerformanceProfile {
  const constrainedMemory =
    typeof navigatorHints.deviceMemory === 'number' && navigatorHints.deviceMemory <= 4;
  const constrainedCpu =
    typeof navigatorHints.hardwareConcurrency === 'number' &&
    navigatorHints.hardwareConcurrency > 0 &&
    navigatorHints.hardwareConcurrency <= 4;
  const constrainedNetwork =
    navigatorHints.connection?.saveData === true ||
    navigatorHints.connection?.effectiveType === '2g' ||
    navigatorHints.connection?.effectiveType === 'slow-2g';

  return reducedMotion || constrainedMemory || constrainedCpu || constrainedNetwork
    ? 'low'
    : 'balanced';
}

export function applyPerformanceProfile(root: HTMLElement): PerformanceProfile {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const profile = resolvePerformanceProfile(navigator as NavigatorPerformanceHints, reducedMotion);
  root.dataset['performance'] = profile;
  return profile;
}
